export default __webpack_public_path__ + "static/diamond-2-4cd1c01949f63f5c17bc49f6e15464ab.png";